module.exports = __webpack_public_path__ + "img/EtikettWidth.cde389be.png";